export enum ReportTemplateRegionType {
  Unknown,
  Header,
  Main,
  MeasurementData,
  Footer,
}
